import { render, staticRenderFns } from "./TourImageSelect.vue?vue&type=template&id=1dc52bcc&scoped=true"
import script from "./TourImageSelect.vue?vue&type=script&lang=js"
export * from "./TourImageSelect.vue?vue&type=script&lang=js"
import style0 from "./TourImageSelect.vue?vue&type=style&index=0&id=1dc52bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc52bcc",
  null
  
)

export default component.exports